module.exports = __webpack_public_path__ + "ec1811bedb68eb27a26375402acee578.png";